import {
  getInFlightOperations,
  pollOperation,
  removeInFlightOperation,
} from '~/services/http/asyncOperation'
import { addNotification } from '~/cynqueModules/addNotification'
import { AsyncOperationError } from '~/services/errors'

export default defineNuxtPlugin(() => {
  const ops = getInFlightOperations()
  if (ops.length === 0) {
    return
  }

  console.debug(
    `[resumeAsyncOperations] Found ${ops.length} in-flight operation(s) — resuming polls`
  )

  for (const op of ops) {
    pollOperation(op.operationId, 'resumeAsyncOperations')
      .then(() => {
        removeInFlightOperation(op.operationId)
        addNotification({
          type: 'info',
          message: `A background operation completed successfully (${op.apiPath}).`,
        })
      })
      .catch((e) => {
        removeInFlightOperation(op.operationId)
        if (e instanceof AsyncOperationError && e.errorType === 'Timeout') {
          console.warn(
            `[resumeAsyncOperations] Operation ${op.operationId} still running`
          )
          return
        }
        addNotification({
          type: 'error',
          message: `A background operation failed: ${e.message}`,
        })
      })
  }
})
